import { useState, useEffect, useRef } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

export const useAdminRole = () => {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const checkedUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    const checkAdminRole = async () => {
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        checkedUserIdRef.current = null;
        return;
      }

      // Skip if we already checked this user
      if (checkedUserIdRef.current === user.id) {
        return;
      }

      checkedUserIdRef.current = user.id;

      // 1. Check metadata logic directly (Faster & Reliable)
      const metaRole = user.user_metadata?.role;

      // Only allow if role is explicitly 'admin' in metadata
      if (metaRole === 'admin') {
        setIsAdmin(true);
        setLoading(false);
        return;
      }

      // 2. Fallback to RPC if metadata isn't set but DB might have it
      try {
        const { data, error } = await supabase
          .rpc('has_role', { _user_id: user.id, _role: 'admin' });

        if (error) {
          console.error("Error checking admin role (RPC):", error);
          setIsAdmin(false);
        } else {
          setIsAdmin(data === true);
        }
      } catch (err) {
        console.error("Error checking admin role:", err);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminRole();
  }, [user?.id]);

  return { isAdmin, loading };
};
